import { render, staticRenderFns } from "./AreaEditMun.vue?vue&type=template&id=4c5f1fe3"
import script from "./AreaEditMun.vue?vue&type=script&lang=ts"
export * from "./AreaEditMun.vue?vue&type=script&lang=ts"
import style0 from "./AreaEditMun.vue?vue&type=style&index=0&id=4c5f1fe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports